export default class Delimiter {
  constructor(data: { label: any; value: any }) {
    this.setData(data);
  }

  setData(data: { label: any; value: any }) {
    const { label, value } = data;

    if (label) {
      this.label = label;
    }

    if (value) {
      this.value = value;
    }
  }

  label = "";
  value = true;
}
